import CargoEquipmentModal from './main.cargo-equipment'

export default CargoEquipmentModal